export const apiUrl="https://dbhrm.devbox.co/dbhrmapi"

// export const apiUrl="http://localhost:4000/dbhrmapi"

export const DEFAULT_SHIFT_DURATION_HOURS=20
// Was "https://placehold.net/avatar-4.png" -- that free-tier image host
// started returning 503 "usage_exceeded" (confirmed 2026-10-22, not a
// transient blip: hit 3x a few seconds apart), which silently broke every
// no-picture avatar across the app (header dropdown, Employees list,
// Profile, dashboard, this constant's 10 real call sites) as a broken-image
// icon. Inline SVG data URI instead -- no network dependency, can't go down.
export const PLACEHOLDER_IMAGE="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'%3E%3Ccircle cx='50' cy='50' r='50' fill='%23CBD5D9'/%3E%3Ccircle cx='50' cy='38' r='18' fill='%238B9A9E'/%3E%3Cpath d='M50 62c-22 0-36 12-36 28v10h72v-10c0-16-14-28-36-28z' fill='%238B9A9E'/%3E%3C/svg%3E"
export const POLICY_DOCUMENTS_URL = "https://drive.google.com/drive/u/0/folders/1jCsFtyELdEdRyztTS0U11QaZAXaqSZ2a";

export const headers = {
    "Content-Type": "application/json; charset=utf-8",
    "Access-Control-Allow-Origin": "*",
    mode: "no-cors"
}

